/**
 * Imported Panelen Store – Phase 2 Material Calculator handoff
 * Slaat panelen op van succesvolle PDF import voor gebruik in Material Calculator.
 * Wordt gevuld via orion-pdf-panelen-ready event (dispatchPdfImportComplete).
 */

import { create } from 'zustand'

export const useImportedPanelenStore = create((set) => ({
  projectId: null,
  panelen: [],
  importedAt: null,

  setImportedPanelen: (projectId, panelen) =>
    set({
      projectId: projectId ?? null,
      panelen: Array.isArray(panelen) ? panelen : [],
      importedAt: new Date().toISOString(),
    }),

  clear: () => set({ projectId: null, panelen: [], importedAt: null }),
}))
